module.exports = __webpack_public_path__ + "img/PH.9124b268.svg";